// Shared voice-command helpers used by the Assistant page and the global VoiceProvider.

// Instant local "stop / arrête" command — intercepted on the frontend (<300ms), never
// sent to the LLM. Kept tight (short standalone utterance) so it can't fire mid-sentence.
const STOP_RE = /^(stop|stoppe|arr[eê]te[rz]?|arr[eê]te[- ]?toi|arr[eê]tez[- ]?toi|arr[eê]t|silence|chut|tais[- ]?toi|wqef|waqef|skout|sket)$/i;

export function isInstantStop(text) {
  let t = (text || "").trim().toLowerCase();
  t = t.replace(/[.!?,;]+$/g, "").trim();
  if (!t) return false;
  if (t.split(/\s+/).length > 2) return false; // only a short standalone command
  return STOP_RE.test(t);
}

// Strip an optional wake word ("Sara", "Hey Sara", "OK Sara"…) from the start of an
// utterance. Returns the remaining text, "" if only the wake word was said, or null if
// the wake word is absent (caller should then ignore the utterance).
export function stripWake(text, wake) {
  const w = (wake || "Sara").trim().toLowerCase();
  const esc = w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const t = (text || "").trim();
  const re = new RegExp(`^(?:h[eé]?y?\\s+|ok\\s+|dis\\s+|eh\\s+|coucou\\s+)?${esc}\\b[\\s,:.!?-]*`, "i");
  if (re.test(t)) return t.replace(re, "").trim();
  const idx = t.toLowerCase().indexOf(w);
  if (idx !== -1 && idx <= 14) {
    return (t.slice(0, idx) + t.slice(idx + w.length)).replace(/^[\s,:.!?-]+/, "").trim();
  }
  return null;
}
